<template>
  <v-app :style="{ background: theme.background, color: theme.text }">

    <v-progress-linear
      v-if="isLoading"
      indeterminate
      absolute
      top
    />

   <router-view v-slot="{ Component }">
      <transition name="fade">
        <component :is="Component" />
      </transition>
    </router-view>

     <HelpCenterLauncher />

     <AccessibilityLauncher />


  </v-app>
</template>

<script setup>
import { ref, provide, onMounted, computed, watch } from "vue"
import publicApi from '@/auth/publicApi'
import api from '@/auth/api'
import { useRouter } from "vue-router"
import { useThemeStore, useAuthStore } from "@/store/auth"
import { useLangStore } from "@/store/lang"
import { useCart } from "@/store/cartStore"
import HelpCenterLauncher from "@/components/HelpCenterLauncher.vue"
import AccessibilityLauncher from "@/components/AccessibilityLauncher.vue"

import toast from 'vue-toastification'
const lang = useLangStore()
const themeStore = useThemeStore()
const theme = computed(() => themeStore.themeStyles)

// ⭐ FIX: define auth so your existing logic works
const auth = useAuthStore()

import { useDisplay } from 'vuetify'
const { mdAndUp, smAndDown } = useDisplay()

import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n()

watch(
  () => lang.currentLanguage,
  (newLang) => { locale.value = newLang },
  { immediate: true }
)

const hospitalRef = ref([])

// CART
const cartStore = useCart()
cartStore.loadCart()
provide("cartStore", cartStore)

// LOADING BAR
const router = useRouter()
const isLoading = ref(false)

router.beforeEach((to, from, next) => {
  isLoading.value = true
  next()
})

router.afterEach(() => {
  isLoading.value = false
})

window.addEventListener('error', (event) => {
  if (event.message.includes('ResizeObserver loop')) {
    event.stopImmediatePropagation()
  }
})

async function fetchTenant(){
    const response = await publicApi.get('/Tenants/current')
    hospitalRef.value = response.data
    localStorage.setItem('TenantId', hospitalRef?.value?.tenantId)
    localStorage.setItem('LogoLight', hospitalRef?.value?.logoLight)
    localStorage.setItem('LogoDark', hospitalRef?.value?.logoDark)

    // ⭐ FIX: now auth is defined
    auth.tenantId = hospitalRef?.value?.tenantId

    // Apply tenant favicon
    let favicon = document.querySelector(
      "link[rel~='icon']"
    )

    if (!favicon) {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      document.head.appendChild(favicon)
    }

    favicon.href =
      hospitalRef?.value?.faviconUrl ||
      '/favicon.ico'

    // ⭐ FIX: now auth is defined
    auth.tenantId =
      hospitalRef?.value?.tenantId

}

onMounted(async () => {
  locale.value = localStorage.getItem('locale')

  if(!locale.value) {
    localStorage.setItem('locale', 'en')
  }

  themeStore.loadThemes()
  fetchTenant()
})
</script>


<style>
.Vue-Toastification__container {
  top: 80px !important; /* 👈 pushes it down */
}
</style>